import { UiDatepicker, UiSelect, UiSwitch } from "@/components/ui";
import { CAMPAGNE_TYPES } from "@/composables/campagne";
import { YES_NO_OPTIONS } from "@/constants";
import { format } from "date-fns";
import { useEffect, useState } from "react";

export type CampagneFilterDataModel = {
  type: string;
  creationDate: string;
  draft?: string;
  shelve?: string;
};

interface CampagneFilterFormProps {
  defaultValue: CampagneFilterDataModel;
  onChange?: ({
    type,
    creationDate,
    draft,
    shelve,
  }: CampagneFilterDataModel) => void;
}

export function CampagneFilterForm({
  onChange,
  defaultValue,
}: CampagneFilterFormProps) {
  const [typeValue, setTypeValue] = useState<string>(defaultValue.type);
  const [draft, setDraft] = useState<string>(defaultValue.draft || "");
  const [shelve, setShelve] = useState<string>(defaultValue.shelve || "");
  const [creationDate, setCreationDate] = useState<string>(
    defaultValue.creationDate
  );

  useEffect(() => {
    if (onChange) onChange({ type: typeValue, creationDate, draft, shelve });
  }, [typeValue, creationDate, draft, shelve]);

  return (
    <div className="flex  gap-2 relative z-10">
      <UiSelect
        options={CAMPAGNE_TYPES}
        defaultValue={defaultValue.type}
        label="Type de campagne"
        groupClassname="flex flex-col gap-1"
        placeholder="Choisissez un type de campagne"
        className="relative z-10"
        onChange={(value) => setTypeValue(value)}
      ></UiSelect>

      <UiDatepicker
        name="dateDebut"
        className="w-full"
        groupClassname="flex flex-col gap-1"
        label="Date de création"
        placeholder="Date de création"
        onChange={(v: Date | null) => {
          setCreationDate(v ? format(v, "yyyy-MM-dd") : "");
        }}
        onClean={(e: React.MouseEvent) => setCreationDate("")}
      />

      <UiSelect
        options={YES_NO_OPTIONS}
        defaultValue={defaultValue.type}
        label="Brouillon ?"
        groupClassname="flex flex-col gap-1"
        placeholder="Brouillon ?"
        onChange={(value) => setDraft(value)}
      ></UiSelect>

      <UiSelect
        options={YES_NO_OPTIONS}
        defaultValue={defaultValue.type}
        groupClassname="flex flex-col gap-1"
        label="Suspendu ?"
        placeholder="Suspendu ?"
        onChange={(value) => setShelve(value)}
      ></UiSelect>
    </div>
  );
}
